import { t } from '../../i18n';

export const ACTION_GENERATE_JOB_POSTING_DESCRIPTION = 'generate_job_posting_description';
export const ACTION_GENERATE_REJECTION_FEEDBACK = 'generate_rejection_feedback';
export const ACTION_GENERATE_INTERVIEW_SCRIPT = 'generate_interview_script';
export const ACTION_GENERATE_SCREENING_QUESTIONS = 'generate_screening_questions';
export const ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE = 'generate_practical_technical_case';
export type SinapseAction =
  | typeof ACTION_GENERATE_JOB_POSTING_DESCRIPTION
  | typeof ACTION_GENERATE_REJECTION_FEEDBACK
  | typeof ACTION_GENERATE_INTERVIEW_SCRIPT
  | typeof ACTION_GENERATE_SCREENING_QUESTIONS
  | typeof ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE
  | 'text'
  | 'audio';

export const COMPETENCY_MAP = {
  1: t('Gestão de Recursos de Pessoas'),
  2: t('Coordenação e Gestão do Tempo'),
  3: t('Gestão de Recursos financeiros e Materiais'),
  4: t('Gerenciamento de Projetos'),
  5: t('Vendas'),
  6: t('Comunicação e Marketing de Produtos e Serviços'),
  7: t('Experiência do Cliente'),
  8: t('Pensamento Analítico'),
  9: t('Pensamento Criativo'),
  10: t('Pensamento Crítico'),
  11: t('Pensamento Sistêmico'),
  12: t('Marketing Digital'),
  13: t('Software e Linguagem de Programação'),
  14: t('Fazendo Perguntas'),
  15: t('Ensino e Treinamento'),
  16: t('Recebendo FeedBack'),
  17: t('Comunicação'),
  18: t('Seguindo Instruções e Procedimentos'),
  19: t('Auxiliar e apoiar os colegas de trabalho'),
  20: t('Empatia'),
  21: t('Persuasão e Negociação'),
  22: t('Relacionamento e Networking'),
  23: t('Demonstrando Consideração'),
  24: t('Liderança Ética'),
  25: t('Construindo Confiança'),
  26: t('Trabalhar de forma independente'),
  27: t('Gerenciamento de tempo e priorização'),
  28: t('Autoconsciência Interna'),
  29: t('Autoconsciência Externa'),
  30: t('Automotivação/Autocontrole'),
  31: t('Curiosidade'),
  32: t('Adaptação à Mudança'),
  33: t('Vontade de Aprender'),
  34: t('Cumprimento de Compromissos e Prazos'),
  35: t('Assumindo Responsabilidade'),
  36: t('Gerenciando a Qualidade'),
  37: t('Organização'),
  38: t('Gerenciamento de Frustrações'),
  39: t('Gerenciamento de Estresse'),
  40: t('Persistência'),
  41: t('Cultura da empresa'),
};
